// src/utils/api.js
import axios from "axios";

class ApiService {
  constructor() {
    this.client = axios.create({ baseURL: "https://api.vet-pen.com/api", headers: { apiKey: "asdasd", "Content-Type": "application/json" } });

    this.client.interceptors.request.use((config) => {
      const token = localStorage.getItem("token");
      const lang = localStorage.getItem("lang") || "en";

      if (token) {
        config.headers.token = token;
        config.headers.Authorization = `Bearer ${token}`;
      }

      config.headers.lang = lang;

      return config;
    });
  }

  // GET
  get(url, params = {}) {
    return this.client.get(url, { params });
  }

  // POST
  post(url, data = {}) {
    return this.client.post(url, data);
  }

  // PUT
  put(url, data = {}) {
    return this.client.put(url, data);
  }

  // PATCH
  patch(url, data = {}) {
    return this.client.patch(url, data);
  }

  // DELETE
  delete(url, data = {}) {
    return this.client.delete(url, { data });
  }
}

export default ApiService;
